import * as React from 'react'
import { useEstimatedDeliveryDate, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import * as SSC from '../Shared.styles'

const PremiumDeliveryCountdown: React.FC<PremiumDeliveryCountdownProps> = ({
  type,
  groupType,
  isPdp = false
}) => {
  const { t } = useTranslation()

  const {
    remainingTime,
    afterCutoffDate,
    beforeCutoffDate,
    isBeforeCutoffTime,
    isBeforeDateTomorrow
  } = useEstimatedDeliveryDate()

  if (!remainingTime) return null

  const conversion = t(`shared.conversion.${groupType}`)
  const pdp = (
    <span
      dangerouslySetInnerHTML={{
        __html: isBeforeCutoffTime
          ? t('shared.premium.order_tomorrow_pdp_conversion', {
              h: remainingTime.hours,
              m: remainingTime.minutes,
              conversion
            })
          : t('shared.premium.order_pdp_conversion', { conversion })
      }}
    />
  )

  const nonPdp = isBeforeCutoffTime
    ? t(`shared.premium.order_tomorrow_conversion`, {
        h: remainingTime.hours,
        m: remainingTime.minutes,
        conversion
      })
    : t(`shared.premium.${type === 'short' ? 'order' : 'buy_now'}`)

  let deliveryDate

  if (isBeforeCutoffTime) {
    deliveryDate = beforeCutoffDate
  } else {
    deliveryDate = afterCutoffDate
  }

  if (isBeforeCutoffTime && isBeforeDateTomorrow && type === 'short') {
    deliveryDate = t('shared.tomorrow')
  }

  return (
    <>
      {isPdp ? pdp : nonPdp}
      <SSC.Underline>{deliveryDate}</SSC.Underline>
    </>
  )
}

export default withTranslations(PremiumDeliveryCountdown)

interface PremiumDeliveryCountdownProps {
  type: 'short' | 'long'
  groupType: string
  isPdp?: boolean
}
